import { selectFinancialYear } from 'legacy/lut/features/partner360/configuration'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { Nullable } from 'cng-common/models/utils'

import { applyMdfActivity } from '../../api'
import { IMdfActivity } from '../types'

interface IRequestMdfActivityApply {
  activity: IMdfActivity
  /** Explicit editor context; falls back to the currently selected financial year. */
  fYear?: number
  /**
   * Key initiative to link to, or `null` to clear the link.
   */
  keyInitiativeId: number | null
  /**
   * Outcome to persist. When omitted, the activity's current outcome is preserved.
   */
  outcome?: string | null
  /**
   * Outcome value type to persist. When omitted, the activity's current value is preserved.
   */
  outcomeValueType?: string | null
  /**
   * Outcome metrics to persist. When omitted, the activity's current values are preserved
   * (e.g. the table's link-only save path doesn't touch these).
   */
  funnelSizeUsd?: Nullable<number>
  leads?: Nullable<number>
  conversionRate?: Nullable<number>
  attendance?: Nullable<number>
  estimatedSalesUsd?: Nullable<number>
}

export const requestMdfActivityApply = createAsyncThunk(
  'mdfActivities/apply',
  (
    {
      activity,
      fYear,
      keyInitiativeId,
      outcome,
      outcomeValueType,
      funnelSizeUsd,
      leads,
      conversionRate,
      attendance,
      estimatedSalesUsd,
    }: IRequestMdfActivityApply,
    { getState }
  ) => {
    const selectedFYear = selectFinancialYear(getState())

    return applyMdfActivity({
      EntryId: activity.entryId,
      ActivityID: activity.activityId,
      PartnerID: activity.partnerId,
      FYear: fYear ?? selectedFYear,
      KeyInitiativeId: keyInitiativeId,
      // KeyInitiativeLinkType: keyInitiativeId === null ? null : 'Manual',
      KeyInitiativeLinkType: 'Manual',
      Outcome: outcome !== undefined ? outcome : activity.outcome,
      OutcomeValueType:
        outcomeValueType !== undefined ? outcomeValueType : activity.outcomeValueType,
      FunnelSize: funnelSizeUsd !== undefined ? funnelSizeUsd : activity.funnelSizeUsd,
      Leads: leads !== undefined ? leads : activity.leads,
      ConversionRate: conversionRate !== undefined ? conversionRate : activity.conversionRate,
      Attendance: attendance !== undefined ? attendance : activity.attendance,
      EstimateSales:
        estimatedSalesUsd !== undefined ? estimatedSalesUsd : activity.estimatedSalesUsd,
    })
  }
)
